var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuaHomeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 75 75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4136 0 0 1.4136 12.762 16.296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.991 14.971c0 1.054-0.912 1.881-1.945 1.881h-1.944l0.042 9.386c0 0.159-0.012 0.317-0.03 0.475v0.943c0 1.295-1.088 2.344-2.431 2.344h-0.972c-0.067 0-0.134 0-0.201-6e-3 -0.085 6e-3 -0.17 6e-3 -0.255 6e-3h-3.433c-1.343 0-2.431-1.049-2.431-2.344v-5.156c0-1.037-0.869-1.875-1.945-1.875h-3.889c-1.076 0-1.945 0.838-1.945 1.875v5.156c0 1.295-1.087 2.344-2.43 2.344h-3.397c-0.092 0-0.183-6e-3 -0.274-0.012-0.073 6e-3 -0.146 0.012-0.219 0.012h-0.972c-1.343 0-2.431-1.049-2.431-2.344v-6.562c0-0.053 0-0.112 6e-3 -0.164v-4.078h-1.95c-1.094 0-1.945-0.821-1.945-1.881 0-0.528 0.182-0.996 0.608-1.406l15.581-13.096c0.425-0.41 0.911-0.469 1.337-0.469 0.425 0 0.911 0.117 1.276 0.41l15.52 13.155c0.487 0.41 0.73 0.878 0.669 1.406z",
    fill: "url(#a)",
    fillRule: "nonzero"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(-26,28,-28,-26,21.5,-3.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2cba88",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750f9",
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2991c",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuaHomeButton);
export default __webpack_public_path__ + "static/media/bua-home-button.aff94b2c104306a2bb8f8290b6925865.svg";
export { ForwardRef as ReactComponent };